import { useQuery } from '@tanstack/react-query'
import { menusApi } from '@/api/endpoints/menus'

/** List all non-deleted menus for a restaurant. */
export function useMenus(restaurantId: number | null) {
  return useQuery({
    queryKey: ['menus', restaurantId],
    queryFn: () => menusApi.listByRestaurant(restaurantId as number),
    enabled: !!restaurantId,
  })
}

/** List daily menus for a restaurant within a date range (feeds the week view). */
export function useMenusWeek(
  restaurantId: number | null,
  from: string,
  to: string,
) {
  return useQuery({
    queryKey: ['menus', restaurantId, 'week', from, to],
    queryFn: () =>
      menusApi.listByRestaurant(restaurantId as number, { from, to }),
    enabled: !!restaurantId && !!from && !!to,
  })
}

/** Get (auto-create) the restaurant's master menu. */
export function useMasterMenu(restaurantId: number | null) {
  return useQuery({
    queryKey: ['menus', restaurantId, 'master'],
    queryFn: () => menusApi.getMaster(restaurantId as number),
    enabled: !!restaurantId,
  })
}
